module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAYCAYAAADOMhxqAAABFklEQVQ4T5WU0Q2CMBCGLQSeCHEDdQMl4b2M4Aa6iU7gCOoExgnoIwkhsgG6gQFeAe8Il4C2UEl4of/X/+/dFTbTfDzP24H0xHT0KGaMneE9TgIkho2vSZLsRgHf99d1XT9IjGmUAIqrqgohxh13puhSQCWWOpAYFl+u63IhxLtfmIED53ye53mmEg8cUFyWZQiHZLKdB2fQFbcOJG6aZmVZ1jqKoudYMxk0JoXSLQ3D4HEcp1OdbwEQLUzTDLSArjICIdu2N5ORMAJBEKtxHCf4rr20D7rQT+OKonhCETKV088sdRMqVJBy+KDjWIgQJnWrnKX+AjnBtxtA+9HxpsXeBboQ9M8VbaFJAN3++glQvO43c/gAOXCqTIbmP4wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/jt_left.png
// module id = L77I
// module chunks = 0